import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomInput from '../CustomInput/CustomInput'
import ar_lang from '../../assets/arlang.png'
import en_lang from '../../assets/lang.svg'
import download from '../../assets/download.png'
import { useNavigate } from 'react-router-dom';
import { toggleDarkMode } from '../../hooks/DarkMode';
import { Dropdown, DropdownButton, Offcanvas } from 'react-bootstrap';
import Sidebar from '../Sidebar/Sidebar';
import { changeLocal } from "../../hooks/Localization";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SettingsIcon from '@mui/icons-material/Settings';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';

import "./AuthNavbar.css"
import { loginMethod } from '../../hooks/auth';
function AuthNavbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleLang = () => {
    dispatch(
      changeLocal(
        currentLocal.language === "English" ? "ar" : "en"
      )
    );
  }
  return (
    <div className='auth_navbar_container px-4 py-3'>


      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton className='border-bottom-0'>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Sidebar />
        </Offcanvas.Body>
      </Offcanvas>
      <div className='search_container normalQuery'>

      </div>
      <div className='mdQuery'>

        <div className='list_container' onClick={() => setShow(true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#212529" className="bi bi-list" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
          </svg>
        </div>
      </div>
      <div className='actions_container'>
        <div className='item_container' onClick={() => dispatch(toggleDarkMode())}>
          {isDarkMode ?
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#212529" className="bi bi-brightness-high-fill" viewBox="0 0 16 16">
              <path d="M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
            </svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#212529" className="bi bi-brightness-high" viewBox="0 0 16 16">
              <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708" />
            </svg>
          }
        </div>
        {/* <div className='item_container'>
          <DropdownButton id="dropdown-basic-button" title={<> <img src={currentLocal.language == "العربيه" ? ar_lang : en_lang} alt='' className='w-75' /></>}>
            <div className='dropdown_text'>{currentLocal.home.ChooseYourLanguage}</div>
            <div className='lang_container'>
              <div className='lang' onClick={handleLang}>
                <img src={currentLocal.language == "العربيه" ? en_lang : ar_lang} alt='' />
                <p className='mb-0 lang_value mx-1'>{currentLocal.language == "العربيه" ? "الانجليزية" : "Arabic"}</p>
              </div>
            </div>
          </DropdownButton>
        </div> */}
        <div className='item_container'>
          <DropdownButton
            id="dropdown-basic-button"
            title={
              <>
                <img
                  src={currentLocal.language === "العربيه" ? ar_lang : en_lang}
                  alt=''
                  className='w-75'
                />
              </>
            }
          >
            <div className='dropdown_text px-3 py-2'>{currentLocal.home.ChooseYourLanguage}</div>

            {/* استخدام Dropdown.Item يضمن الإغلاق التلقائي عند النقر */}
            <Dropdown.Item
              as="div"
              className='lang_container'
              onClick={handleLang}
            >
              <div className='lang d-flex align-items-center' style={{ cursor: "pointer" }}>
                <img
                  src={currentLocal.language === "العربيه" ? en_lang : ar_lang}
                  alt=''
                  width="20"
                />
                <p className='mb-0 lang_value mx-2 text-dark'>
                  {currentLocal.language === "العربيه" ? "الانجليزية" : "Arabic"}
                </p>
              </div>
            </Dropdown.Item>
          </DropdownButton>
        </div>
        <div className='item_container account_dropdown'>
          <DropdownButton
            id="dropdown-basic-button"
            title={
              <>
                <img
                  src={download}
                  alt=''
                  className='w-75'
                />
              </>
            }
          >

            {/* استخدام Dropdown.Item يضمن الإغلاق التلقائي عند النقر */}
            <Dropdown.Item
              as="div"
              className='lang_container'
              onClick={() => navigate("/dashboard/profile")}
            >
              <div className='lang d-flex align-items-center' style={{ cursor: "pointer" }}>
                <PermIdentityIcon

                />
                <p className='mb-0 lang_value mx-2 text-dark'>
                  {currentLocal.home.profile}
                </p>
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              as="div"
              className='lang_container'
              onClick={() => navigate("/dashboard/edit-profile")}
            >
              <div className='lang d-flex align-items-center' style={{ cursor: "pointer" }}>
                <SettingsIcon

                />
                <p className='mb-0 lang_value mx-2 text-dark'>
                  {currentLocal.home.settings}
                </p>
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              as="div"
              className='lang_container'
              onClick={() => {
                dispatch(loginMethod({}))
                navigate("/")

              }}
            >
              <div className='lang d-flex align-items-center' style={{ cursor: "pointer" }}>
                <PowerSettingsNewIcon

                />
                <p className='mb-0 lang_value mx-2 text-dark'>
                  {currentLocal.home.logout}
                </p>
              </div>
            </Dropdown.Item>
          </DropdownButton>
        </div>
        {/* <div className='item_container' onClick={() => navigate("/dashboard/notifications")}>
    
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#212529" className="bi bi-bell" viewBox="0 0 16 16">
            <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
          </svg></div> */}
      </div>
    </div>
  )
}

export default AuthNavbar
